/* unplugin-vue-components disabled */import { render } from "./NineGridRender.vue?vue&type=template&id=924cc926&scoped=true"
import script from "./NineGridRender.vue?vue&type=script&lang=js"
export * from "./NineGridRender.vue?vue&type=script&lang=js"

import "./NineGridRender.vue?vue&type=style&index=0&id=924cc926&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-924cc926"]])

export default __exports__